import { render, staticRenderFns } from "./cashbackActivity2.vue?vue&type=template&id=cc8e8128&scoped=true&"
import script from "./cashbackActivity2.vue?vue&type=script&lang=js&"
export * from "./cashbackActivity2.vue?vue&type=script&lang=js&"
import style0 from "./cashbackActivity2.vue?vue&type=style&index=0&id=cc8e8128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8e8128",
  null
  
)

export default component.exports